import { createSelector } from '@ngrx/store';

import {
  selectVistaUsuario,
  VistaUsuarioState
} from '../../vista-usuario/vista-usuario.state';

import {
  EntityTiposTecnicoState,
  entityTiposTecnicoAdapter
} from './entity-tipos-tecnico.state';

const { selectEntities, selectAll } = entityTiposTecnicoAdapter.getSelectors();

export const getError = (state: EntityTiposTecnicoState): any => state.error;

export const getIsLoading = (state: EntityTiposTecnicoState): boolean =>
  state.isLoading;

export const selectTiposTecnicoState = createSelector(
  selectVistaUsuario,
  (state: VistaUsuarioState) => state.tiposTecnico
);

export const selectAllTiposTecnico = createSelector(
  selectTiposTecnicoState,
  selectAll
);
export const selectEntitiesTiposTecnico = createSelector(
  selectTiposTecnicoState,
  selectEntities
);

// MemoizedSelector<object,any>
export const selectTiposTecnicoError = createSelector(
  selectTiposTecnicoState,
  getError
);

// MemoizedSelector<object,any>
export const selectTiposTecnicoIsLoading = createSelector(
  selectTiposTecnicoState,
  getIsLoading
);
